import React from 'react';
import { Link } from "react-router-dom";
import Slider from 'react-slick';
import * as S from './style';
import { CTAButtonWrapper } from '../../../../common/styled-components/styled-components';
import { getData, sliderSettings } from "./data";
import Image from '../../../../../../app/js/components/loggedout/common/Image';
import QuoteIcon from "~images/sem/quote_icon.svg";
import KajuIcon from "~images/sem/kaju.svg";
import BlockIcon from "~images/sem/block_icon.svg";
import Routes from "../../../../routes/routes";
import { CTAPrimaryButton } from '../../../../../../app/js/components/loggedout/shared-styles/CTAPrimaryButton';

const Testimonials = ({ settings, trackPromoPageEvents }) => {
  const data = getData();
  let ctaText = settings.trial_days ? `Try free for ${settings.trial_days} days` : 'Subscribe Now';
  return (
    <S.ContainerWrapper>
      <S.ContentWrapper>
        <S.QuotesIcon>
          <Image src={QuoteIcon} />
        </S.QuotesIcon>
        <S.BlockIcon>
          <Image src={BlockIcon} />
        </S.BlockIcon>
        <S.KajuIcon>
          <Image src={KajuIcon} />
        </S.KajuIcon>

        <Slider {...sliderSettings}>
          {
            data.map((item, idx) => {
              return (
                <S.InfoWrapper key={idx}>
                  <S.InfoTitle>
                    {item.title}
                  </S.InfoTitle>
                  <S.InfoItem>
                    <S.InfoIcon>
                      <Image src={item.image} isCdnImage={item.isCdnImage} />
                    </S.InfoIcon>
                    <S.InfoDetails>
                      <S.InfoName>{item.name}</S.InfoName>
                      <S.InfoDesignation>{item.designation}</S.InfoDesignation>
                    </S.InfoDetails>
                  </S.InfoItem>
                </S.InfoWrapper>
              )
            })
          }

        </Slider>
      </S.ContentWrapper>
      <CTAButtonWrapper>
        <CTAPrimaryButton darkBlue={true}>
          <Link to={Routes.PURCHASE_ROUTE} onClick={() => trackPromoPageEvents("Promo Page Interacted", { 'clicked_on': 'CTA2' }, true)}>
            {ctaText}
          </Link>
        </CTAPrimaryButton>
      </CTAButtonWrapper>
    </S.ContainerWrapper>
  )
}

export default Testimonials;